import { makeBaseEntitiesState, makeDefaultEntitiesState } from '@modules/app-common/state/entities.state';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { CareerHousesSchemaIntrospectionGQL, FindCareerHousesGQL, CareerHouse } from 'generated/graphql';
import { keyBy } from 'lodash';
import { Observable, tap } from 'rxjs';

export class CareerHousesFindManyAction {
  static readonly type = '[Career Houses] Find Many';

  constructor() {}
}

export class CareerHousesSchemaIntrospection {
  static readonly type = '[Career Houses] Schema Introspection';

  constructor() {}
}

const CareerHousesBaseEntitiesState = makeBaseEntitiesState<CareerHouse>('careerHouses');

@State({
  name: 'careerHouses',
  defaults: makeDefaultEntitiesState(),
})
@Injectable()
export class CareerHousesEntitiesState extends CareerHousesBaseEntitiesState {
  store = inject(Store);
  findCareerHousesGQL = inject(FindCareerHousesGQL);
  // careerHousesSchemaIntrospectionGQL = inject(CareerHousesSchemaIntrospectionGQL);

  @Selector()
  static schema(state: { schema: any }) {
    return state.schema;
  }

  @Selector()
  static keys(state: { entityMap: Record<string, CareerHouse> }) {
    return Object.values(state.entityMap).map((house) => house.key);
  }

  @Selector()
  static entityMapByKey(state: { entityMap: Record<string, CareerHouse> }) {
    return keyBy(Object.values(state.entityMap), 'key');
  }

  @Action(CareerHousesFindManyAction)
  find(ctx: StateContext<any>, action: CareerHousesFindManyAction): Observable<any> {
    return this.findCareerHousesGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      tap((result) => {
        this.patchEntities(ctx, result.data.findCareerHouses as CareerHouse[]);
      })
    );
  }

  // @Action(CareerHousesSchemaIntrospection)
  // schemaIntrospection(ctx: StateContext<any>, action: CareerHousesSchemaIntrospection) {
  //   return this.careerHousesSchemaIntrospectionGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
  //     tap((result) => {
  //       this.patchSchema(ctx, result.data.__type);
  //     })
  //   );
  // }
}
